import { defHttp } from '../axios';
import { EN_CONVERT_STATUS } from '/@/views/modules/shanshe/components/folders/type';
import { EN_ROLE_LEVEL } from '/@/views/modules/shanshe/enums/roleLevelEnum';

const ES_FIND_BY_CONDITION_URL = '/doMistServer/esResource/findByCondition';
const ES_FIND_BY_CONDITION_ORIGIN_URL = '/doMistServer/esResource/findByConditionOriginal';
const ES_FIND_BY_CONDITION_PLUS_URL = '/doMistServer/esResource/findByConditionPlus';
const ES_GET_PROPERTIES_URL = '/doMistServer/mistResource/resource/:id/properties';

export interface ISortCondition {
  /**
   * 排序
   */
  sortVo?: {
    /**
     * 排序字段
     */
    orderBy: string;
    /**
     * 倒序/升序
     */
    sort: EN_SORT;
  };
}

export enum EN_SORT {
  ASC = 'asc',
  DESC = 'desc',
}

export enum EN_AUTH {
  PRIVATE_READ_WRITE = 0,
  PUBLIC_READ = 1,
  PUBLIC_READ_WRITE = 2,
}

export enum EN_TEMPLATE_MODAL_TYPE {
  ADD = '新增图框',
  RELOAD = '重新上传图框',
  RECHANGE = '替换',
}

/**
 * ES通用查询条件
 */
export interface IFindByConditionRequest extends ISortCondition {
  /**
   * 范围查询
   */
  between?: string;
  /**
   * 创建者
   */
  createBy?: string;

  deep?: number;

  /**
   * 根据id查询, 和ids互斥
   */
  id?: string;
  /**
   * 根据一堆id查询, 和id互斥
   */
  ids?: string[];
  /**
   * true: 带着孙子一起查
   * false: 只查一级
   */
  includeAllChildren?: boolean;

  /**
   * 根据name 模糊查询
   */
  name?: string;

  /**
   * 根据pid查询,和pids互斥
   */
  pid?: string;

  /**
   * 根据一堆pid查询,和pid互斥
   */
  pids?: string[];

  /**
   * 根据项目id查询
   */
  projectId?: string;

  /**
   * 根据props查询
   */
  props?: Record<string, string | undefined>;

  /**
   * 根据tags查询
   */
  tags?: string[];
  /**
   * 根据resourceid查询
   */
  types?: string[];

  /**
   * 根据租户查询
   */
  tenantId?: string | null;
  /**
   * 根据用户查询
   */
  userId?: string;

  /**
   * 根据tag
   */
  resourceCode?: string;

  /**
   * 多组筛选条件
   */
  sortVos?: {
    /**
     * 排序字段
     */
    orderBy: string;
    /**
     * 倒序/升序
     */
    sort: EN_SORT;
  }[];

  /**
   * 页码
   */
  pageNumber?: number;

  /**
   * 一页几个
   */
  pageSize?: number;

  force?: boolean;

  /**
   * 模糊搜索
   */
  searchText?: string;

  community?: string;

  auth?: EN_AUTH;

  /**
   * 0 : 回收站中的数据
   * 1 : 正常的数据
   */
  recycleBin?: 0 | 1;
}

export interface IFindByConditionPlusRequest extends ISortCondition {
  conditionRelationship: 'and' | 'or';
  conditions: IFindByConditionRequest[];
}

export interface IPagedResponse<T> {
  result: T;
  pageNumber: number;
  pageSize: number;
  total: number;
}

export interface IPermissionWrapper {
  permission: IPermission;
}
export interface IPermission {
  isExtend: boolean;
  level: EN_ROLE_LEVEL;
  path: string;
  pathLevel: number;
  roleCode: string;
  roleId: string;
  roleName: string;
  userId: string;
}

export interface ITemplateResult extends IFindByConditionResponse {
  id: string;
  pid: string;
  /** 模板名称 */
  name: string;
  /** 模板文件存放地址 */
  dwgTemplateFileAddress: string;
  /** 模板解析结果存放地址 */
  dwgTemplateParsed: string;
}

export interface IFindByConditionResponse extends IPermissionWrapper {
  projectpartSource: string;
  updateTime?: string;
  pidName: string;
  loadingProgress?: number;
  partGroupColor?: string;
  partIsMain?: string;
  projectType?: string;
  projectProjectValue?: string;
  projectStandardId?: string;
  projectDrawingValue?: string;
  projectPart_convert_result?: EN_CONVERT_STATUS;
  projectPart_file_type?: string;
  projectPart_img_url?: string;
  dwgProjectLibraryType?: string;
  dwgFrameParsed?: string;
  dwgLegendThumbnail?: string;
  dwgLegendMatches?: string; //dwgLegend的技术要求匹配文件，oss地址
  dwgTemplatePartTypeCollection?: string; //dwgTemplatePartType的集合，oss地址
  dwgTemplateParsed?: string;
  dwgTemplateFileAddress?: string;
  projectPart_file_address?: string; //项目文件oss地址
  /**
   * 业务排序
   */
  businessSort: number;
  type: string;
  code: string;
  createBy: string;
  createTime: string;
  id: string;
  name: string;
  path: string;
  pid: string;
  children?: IFindByConditionResponse[];
  icon?: string;
  value?: string;
  images?: string[];
  count?: number;
  colorSettingOssAddress?: string;
  partTemplateFrame?: string;
  partTemplateTechnical?: string;
  partMaterialDensity?: string;
  partMaterialColor?: string;
  partMaterialKFactor?: string;
  spaceBranchLibrary: string; //企业所属品系
  manufacturerStandardLibraryDrawingJsonUrl: string;
  manufacturerStandardLibraryConfig: string;
  manufacturerStandardLibraryBranch: string;
  manufacturerStandardLibraryDesignType: string; //厂家标准的设计类型
  dwgProjectLibraryConfigAddress: string;
  spaceConfig: string;
  drawingAmounts?: string;
  rcMaterialSku?: string;
  rcMaterialDensity?: string;
  rcMaterialCraft?: string;
  spaceRelTenantId?: string;
}

export interface IFindByConditionOriginResponse extends IPermissionWrapper {
  /**
   * 业务排序
   */
  businessSort: number;
  type: string;
  code: string;
  createBy: string;
  createTime: string;
  id: string;
  name: string;
  path: string;
  pid: string;
  icon?: string;
  value?: string;
  images?: string[];
  count?: number;
  props: any[];
  tags: any[];
  permissions: any[];
}

export interface IFindByConditionOptions {
  tenantId?: string;
  pageNumber?: number;
  pageSize?: number;

  /**
   * 是否平铺数据
   */
  tile?: boolean;
}

const findByCondition = <T>(params: IFindByConditionRequest, options?: IFindByConditionOptions) => {
  return defHttp.post<IPagedResponse<(IFindByConditionResponse & T)[]>>({
    url: ES_FIND_BY_CONDITION_URL,
    data: params,
    params: {
      tenantId: options?.tenantId,
      pageNumber: options?.pageNumber ? options.pageNumber : 1,
      pageSize: options?.pageSize ? options.pageSize : 20,
      tile: options?.tile,
    },
  });
};

const findByConditionOriginal = <T>(
  params: IFindByConditionRequest,
  options?: IFindByConditionOptions
) => {
  return defHttp.post<IPagedResponse<(IFindByConditionOriginResponse & T)[]>>({
    url: ES_FIND_BY_CONDITION_ORIGIN_URL,
    data: params,
    params: {
      tenantId: options?.tenantId,
      pageNumber: options?.pageNumber ? options.pageNumber : 1,
      pageSize: options?.pageSize ? options.pageSize : 20,
      tile: options?.tile,
    },
  });
};

const findByConditionPlus = <T>(
  params: IFindByConditionPlusRequest,
  options?: IFindByConditionOptions
) => {
  return defHttp.post<IPagedResponse<(IFindByConditionResponse & T)[]>>({
    url: ES_FIND_BY_CONDITION_PLUS_URL,
    data: params,
    params: {
      tenantId: options?.tenantId,
      pageNumber: options?.pageNumber ? options.pageNumber : 1,
      pageSize: options?.pageSize ? options.pageSize : 20,
      tile: options?.tile,
    },
  });
};

const createEsHelper = () => {
  return {
    findByCondition,
    findByConditionOriginal,
    findByConditionPlus,
    findEnumsByPid: (pid: string, resourceCode?: string, includeAllChildren = false) =>
      pid
        ? findByCondition(
            {
              pid,
              includeAllChildren,
              auth: resourceCode ? undefined : EN_AUTH.PUBLIC_READ,
              sortVo: {
                orderBy: 'sort',
                sort: EN_SORT.ASC,
              },
              resourceCode,
            },
            {
              pageNumber: 1,
              pageSize: 9999,
            }
          )
        : { result: [] },
    findEnumsTreeByPid: (pid: string) =>
      findByCondition(
        {
          pid,
          auth: EN_AUTH.PUBLIC_READ,
          includeAllChildren: true,
          deep: 5,
          sortVo: {
            orderBy: 'sort',
            sort: EN_SORT.ASC,
          },
        },
        {
          pageNumber: 1,
          pageSize: 9999,
        }
      ),
    getPropertiesByResourceId: (id: string) =>
      defHttp.get({
        url: ES_GET_PROPERTIES_URL.replaceAll(':id', id),
      }),
    //根据项id查询方案图纸数量
    getDrawingAmountByProject: (params: any) =>
      defHttp.post({
        url: '/doMistServer/mistProject/getDrawingAmountByProject',
        params,
      }),

    //获取闪设零件
    getConnectShanshePart: () =>
      defHttp.get({
        url: `${window.ENV_CONFIG.baseUrl}/nodeRedService/getDesignorderPartType`,
      }),
  };
};

export const esHelper = createEsHelper();
